module.exports = __webpack_public_path__ + "static/img/6-3.30bad92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/6-3.png
// module id = xGqL
// module chunks = 1